import { useCallback, useEffect, useState } from 'react';

import { useWindowSize } from 'state/window-size';

export enum MediaQuery {
  Mobile = 'mobile',
  MobileTiny = 'mobileTiny',
  MobileSmall = 'mobileSmall',
  MobileLandscape = 'mobileLandscape',
  Desktop = 'desktop',
  DesktopLarge = 'desktopLarge',
  DesktopNotKiosk = 'desktopNotKiosk',
  MobileFullscreen = 'mobileFullscreen',
  Kiosk = 'kiosk'
}

const useMediaQuery = (mq: string): boolean => {
  const dims = useWindowSize();
  const matchMedia = useCallback(() => {
    if (typeof Styles[mq] === 'function') {
      const query = Styles[mq]``[0].replace(/(@media screen and |\{)/g, ''); // compat with Styles[mq]
      return window.matchMedia(query).matches;
    }
    return window.matchMedia(mq).matches;
  }, [mq]);
  const [matches, setMatches] = useState(matchMedia());
  useEffect(() => {
    setMatches(matchMedia());
  }, [matchMedia, dims]);
  return matches;
};

export default useMediaQuery;
